/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export * from './user-account-root.module';
export * from './facade/index';
export * from './model/index';
export * from './events/index';
export * from './feature-name';

/** AUGMENTABLE_TYPES_START */
export { User } from './model/user.model';
/** AUGMENTABLE_TYPES_END */
